import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AvatarDto } from '../../../models/dtos/avatar.dto';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import getAvatarsRequest from './getAvatars.repository';

type InitialState = {
  loading: boolean;
  data?: AvatarDto[];
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getAvatars = createAsyncThunk('getAvatars', async () => {
  return await getAvatarsRequest();
});

const getAvatarsSlice = createSlice({
  name: 'getAvatars',
  initialState,
  reducers: {
    getAvatarsReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAvatars.pending, (state) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    });
    builder.addCase(
      getAvatars.fulfilled,
      (state, action: PayloadAction<AvatarDto[]>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getAvatars.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default getAvatarsSlice.reducer;
export const { getAvatarsReset } = getAvatarsSlice.actions;
